// extracted by mini-css-extract-plugin
module.exports = {"tagLine":"TagLine_tagLine__1ILAO","wrapper":"TagLine_wrapper__ydyzN","tagLabel":"TagLine_tagLabel__o4pd3","tagIcon":"TagLine_tagIcon__EGH8n"};